import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing the FilterAutoexclusionUsersView.
 * @extends JetView
 */
export default class FilterAutoexclusionUsersView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the form
        const left = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'text', // Text input for ID
                    name: 'Id',
                    type: 'number',
                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                    labelPosition: 'top',
                    placeholder: _('Id'),
                    invalidMessage: _('ID is required'), // Validation message
                },
                {
                    view: 'richselect', // Dropdown for Categories
                    name: 'Categorie',
                    localId: 'categorie:combo',
                    label: _("<span class='icon-category'></span> Categorías"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                },
                {
                    view: 'text', // Text input for User Modified
                    name: 'UserModified',
                    label: _("<span class='icon-mode_edit'></span> Usuario Modificó"),
                    labelPosition: 'top',
                    placeholder: _('Usuario Modificó'),
                    invalidMessage: _('Usuario Modificó is required'), // Validation message
                },
                {
                    view: 'richselect', // Dropdown for Games
                    name: 'Game',
                    localId: 'game:combo',
                    label: _("<span class='icon-games'></span> Juego"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                },
            ],
        };

        // Center left section of the form
        const center_left = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'richselect', // Dropdown for Activation Status
                    name: 'IsActivate',
                    label: _("<span class='icon-state'></span> Estado"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'null', value: 'Todos' }, // Option for all
                        { id: 'A', value: 'Activado' }, // Option for activated
                        { id: 'I', value: 'Inactivado' }, // Option for deactivated
                    ],
                },
                {
                    view: 'richselect', // Dropdown for Sub Categories
                    name: 'SubCategory',
                    localId: 'subCategorie:combo',
                    label: _("<span class='icon-subcategory'></span> Sub Categoría"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                },
                {
                    view: 'text', // Text input for User Creation
                    name: 'UserCreation',
                    label: _("<span class='icon-folder-add'></span> Usuario Creación"),
                    labelPosition: 'top',
                    placeholder: _('Usuario Creación'),
                    invalidMessage: _('Usuario Creación is required'), // Validation message
                },
                {
                    view: 'text', // Readonly text input for Datepicker
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: _("<span class='webix_icon icon-calendar'></span> Fecha"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        // Center right section (currently empty)
        const center_right = {
            margin: 5,
            minWidth: 100,
            rows: [],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            minWidth: 100,
            rows: [],
        };

        // Upper section combining left and center left
        const upper_section = {
            margin: 10,
            cols: [left, center_left],
        };

        // Buttons section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key triggers this button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('autoexclusionUsers:filter', [
                            filterdata, // Trigger filter event with form data
                        ]);
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
